export default __webpack_public_path__ + "static/media/ProductsList_img1_Hk.894ea788.webp";